{
  "info": "Informacije",
  "negative": "Pogreška",
  "notice": "Upozorenje",
  "positive": "Uspješno"
}
